function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) =>
/*#__PURE__*/
React.createElement("svg", _extends({
  viewBox: "0 0 12 18"
}, props),
/*#__PURE__*/
React.createElement("path", {
  fill: "#969EA2",
  fillRule: "evenodd",
  d: "M11.99 4.974l.017 2.01a5.97 5.97 0 01-3.105 5.296c-.974.539-1.637 1.525-1.627 2.645l.018 3.09-2.4.02-.018-3.1c-.009-1.12-.688-2.084-1.672-2.605A5.982 5.982 0 01.017 7.087L0 5.077l2-.017-.034-4A1.003 1.003 0 012.957.051a1.004 1.004 0 011.009.992L4 5.042l4-.034-.034-4A1.001 1.001 0 018.957 0a1.003 1.003 0 011.009.991l.034 4 1.99-.017z"
})));